import debounce from 'lodash/debounce'

import OUTPUT_HELPER_DATA from '../../common/json/OUTPUT_HELPER_DATA.json'

import { MESH_MATERIALS } from '../../../../utils/constants'
import { APPLICATION_TYPES_VALUE, OVERHANG_LENGTH } from '../../common/constants'
import { toDegree, numberFormatted, calcPitch, hashCode } from '../../../../utils/fns'

import { resultActions, uiActions } from '../slices'

const populateGraphicData = (calculationState) => {
  const { wall, roof, jobSettings } = calculationState.input
  const selectedModel = calculationState.output.result.selectedModel

  const wallData = {
    material: MESH_MATERIALS[wall.memberType.toUpperCase()] ?? MESH_MATERIALS.SOLID_SAWN,
    applicationType: APPLICATION_TYPES_VALUE[wall.applicationType.toUpperCase()],
    topPlateThickness: wall.topPlateThickness,
    topPlateWidth: wall.topPlateWidth,
    topPlatePlies: wall.topPlatePlies,
    memberType: wall.memberType === 'plate' ? MESH_MATERIALS.SOLID_SAWN : wall.memberType,
    studAlignment: wall.studAlignment,
    studAlignmentOffset: wall.studAlignmentOffset,
    studThickness: wall.studThickness,
    studPlies: wall.studPlies,
    wallLength: jobSettings.wallLength,
  }

  const roofData = {
    memberType: roof.memberType,
    topChordSlope: toDegree(calcPitch(roof.topSlope)),
    bottomChordSlope: toDegree(calcPitch(roof.bottomSlope)),
    heelHeight: roof.heel,
    overhang: roof.overhang,
    overhangLength: roof.overhang ? OVERHANG_LENGTH : 0,
    thickness: roof.width,
    seatCut: wall.topPlateWidth,
    topChordDepth: roof.topChordDepth,
    bottomChordDepth: roof.bottomChordDepth,
    endVerticalDepth: roof.endVerticalDepth,
    ply: roof.ply,
    ijoistDepth: roof.topChordDepth,
    ijoistFlangeThickness: roof.thickness,
    ijoistFlangeWidth: roof.width,
    ijoistVertThickness: 0.375,
    bottomCantilever: roof.overhang,
    material: MESH_MATERIALS.SOLID_SAWN,
  }

  const data = { wall: wallData, roof: roofData }

  if (selectedModel) {
    const connectorsData = {
      sdwcModel: `${selectedModel.model}_${
        OUTPUT_HELPER_DATA.configuration[selectedModel.configuration]
      }`,
      sdwcConnectorQuantity: selectedModel.quantity,
      resistingModel:
        selectedModel.additionalHardware === 'N/A' ? 'NONE' : selectedModel.additionalHardware,
      resistingConnectorQuantity:
        selectedModel.additionalHardwareQuantity === 'N/A'
          ? 1
          : selectedModel.additionalHardwareQuantity,
    }

    connectorsData.connectorSetName = hashCode(
      JSON.stringify(Object.assign({}, data, { connectors: connectorsData })),
    )

    data.connectors = connectorsData
  }

  const formattedValues = numberFormatted(data)

  return formattedValues
}

const debouncePopulateFunc = debounce(({ dispatch, getState }) => {
  const state = getState()

  const graphicsData = populateGraphicData(state.calculation)

  dispatch(uiActions.modifyInput({ name: 'graphicsData', value: graphicsData }))
}, 250)

const handleCalculationActions = (store) => (next) => (action) => {
  next(action)

  if (action.type === resultActions.setSelectedModel.type) {
    debouncePopulateFunc(store)
  }
}

export default handleCalculationActions
